import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectSelectedResult = (state: RootState) =>
	state?.results?.selectedResult;
